// export const CATEGORIES = {
//   category1: "Medicaid and Medicare DME",
//   category2: "OutPatient",
//   category3: "In-Patient",
//   category4: "Commercial HomeHealth",
//   category5: "Therapies",
//   category6: "Imaging",
// }

export const CATEGORIES = {
  category1: "Medicaid and Medicare DME",
  category2: "OutPatient",
}

export const PARENT_PROPERTIES = [
  "Member",
  "Order_Service_HCPCS_CPT_Code",
  "Order_Service_Diagnosis_Code",
  "Requesting_Provider",
  "Treating_Provider",
  "Urgent",
  // "Ordering_Provider",
  // "Order_Feeding",
  // "Order_Medication",
  // "OP_Therapy",
  // "Inpatient",
  // "Home_Health_SkilledNursing",
  // "Imaging",
  // "Order_Service_Commercial_Therapies",
  // "Receiving_Fax_Number",
]

export const PARENT_PROPERTIES_REQUIRED_FIELDS = {
  Member: ["Name_First", "Name_Last", "DOB", "ID"],
  Order_Service_HCPCS_CPT_Code: [
    "HCPCS_CPT_Code",
    "Quantity",
    "Service_Start_Date",
    "Service_End_Date",
    "Rental_Purchase",
    // "HCPCS_Diagnosis_Code",
    // Ordering_Provider: ["NPI", "Tax_id"],
    // "Left_or_Right",
  ],
  Order_Service_Diagnosis_Code: ["Diagnosis_Code"],
  Requesting_Provider: ["NPI", "Tax_id"],
  Treating_Provider: ["NPI", "Tax_id"],
  Urgent: ["Urgency_Detected"],
  // Order_Feeding: [
  //   "Enteral_Nutrition",
  //   "Feeding_Method",
  //   "Can_Calories_Day",
  //   "OTC",
  // ],
  // Inpatient: [
  //   "Inpatient",
  //   "Observation",
  //   "Elective_Inpatient",
  //   "IRF/IPR",
  //   "LTAC",
  //   "SNF",
  // ],
}

export const MISSED_FIELDS = {
  Order_Service_HCPCS_CPT_Code: [
    "HCPCS_CPT_Code",
    "HCPCS_Diagnosis_Code",
    "Quantity",
    "Service_Start_Date",
    "Service_End_Date",
  ],
}

export const ORGANIZATION_TYPES = [
  "OPT_MA",
  "OPT_DSNP",
  "OPT_OHCC",
  "OPT_OFC",
  "OPT_COMM",
  "OPT_SENTARA",
]
